module.exports = __webpack_public_path__ + "img/HQ-G45-V1-ALL.11f4daeb.png";